export default {
	state: {
		overviewImage: null,
		vehicleKilometrage: null,
		orderType: null,
		customer: null,
		vehicle: null,
	},
	getters: {
		getProcessCreateOrderDocumentation(state) {
			return state;
		},
	},
	mutations: {
		setProcessCreateOrderDocumentationCustomer(state, payload) {
			state.customer = payload;
		},
		setProcessCreateOrderDocumentationVehicle(state, payload) {
			state.vehicle = payload;
		},
		setProcessCreateOrderDocumentationOverviewImage(state, payload) {
			state.overviewImage = payload;
		},
		setProcessCreateOrderDocumentationVehicleKilometrage(state, payload) {
			state.vehicleKilometrage = payload;
		},
		setProcessCreateOrderDocumentationOrderType(state, payload) {
			state.orderType = payload;
		},
		clearProcessCreateOrderDocumentation(state) {
			state.overviewImage = null;
			state.orderType = null;
			state.customer = null;
			state.vehicle = null;
		},
	},
	actions: {},
};
